import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

// Slim top banner shown while the browser is offline. The precached app shell
// still renders; API-driven views degrade rather than white-screen.
export function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== "undefined" && !navigator.onLine,
  );

  useEffect(() => {
    const online = () => setOffline(false);
    const goneOffline = () => setOffline(true);
    window.addEventListener("online", online);
    window.addEventListener("offline", goneOffline);
    return () => {
      window.removeEventListener("online", online);
      window.removeEventListener("offline", goneOffline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-50 flex items-center justify-center gap-2 bg-destructive/10 px-4 py-2 text-sm font-medium text-destructive">
      <WifiOff className="h-4 w-4" />
      You&rsquo;re offline. Some data may be unavailable until you reconnect.
    </div>
  );
}
